import { render, staticRenderFns } from "./PosterSort.vue?vue&type=template&id=65aa1445&"
import script from "./PosterSort.vue?vue&type=script&lang=js&"
export * from "./PosterSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports